// 天天漫画网 模拟数据（内容展示用）

export interface Comic {
  id: number;
  title: string;
  author: string;
  status: string;
  genre: string;
  chapters: number;
  rating: number;
  heat: number;
  tags: string[];
  description: string;
  cover: string;
  updateTime: string;
  latestChapter: string;
  viewCount: string;
}

export interface UpdateItem {
  id: number;
  comicId: number;
  title: string;
  chapter: string;
  time: string;
  tag: string;
  cover: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const genres = [
  { name: "热血", icon: "ri-fire-fill", color: "primary" },
  { name: "奇幻", icon: "ri-sparkling-2-fill", color: "secondary" },
  { name: "科幻", icon: "ri-rocket-2-fill", color: "accent" },
  { name: "恋爱", icon: "ri-heart-3-fill", color: "primary" },
  { name: "冒险", icon: "ri-compass-3-fill", color: "secondary" },
  { name: "悬疑", icon: "ri-search-eye-fill", color: "accent" },
  { name: "校园", icon: "ri-graduation-cap-fill", color: "primary" },
  { name: "美食", icon: "ri-restaurant-fill", color: "accent" },
  { name: "搞笑", icon: "ri-emotion-happy-fill", color: "secondary" },
  { name: "武侠", icon: "ri-sword-fill", color: "primary" },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: "星海之刃",
    author: "林晚星",
    status: "连载中",
    genre: "科幻",
    chapters: 328,
    rating: 9.4,
    heat: 982100,
    tags: ["星际", "热血", "机甲"],
    description: "末世纪元，人类舰队驶向深空。少年剑客在一次跃迁事故中意外觉醒星辰之力，从此踏上对抗深渊势力的征途。高燃的战斗场面与层层揭开的星际阴谋交织，每一话都让读者欲罢不能。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20heroic%20young%20swordsman%20holding%20a%20glowing%20blade%20aboard%20a%20futuristic%20spaceship%2C%20starry%20nebula%20backdrop%2C%20dynamic%20dramatic%20pose%2C%20vibrant%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%202D%20anime%20art&width=480&height=640&seq=comic-cover-01&orientation=portrait",
    updateTime: "今天 09:20",
    latestChapter: "第328话 · 深渊之门",
    viewCount: "982万",
  },
  {
    id: 2,
    title: "九霄破",
    author: "青竹",
    status: "连载中",
    genre: "玄幻",
    chapters: 512,
    rating: 9.6,
    heat: 1203400,
    tags: ["修仙", "国漫", "热血"],
    description: "废柴少年偶得上古神诀，逆天改命踏碎九霄。从无名小卒到傲视仙域，一路热血斗法、热血燃情。国漫扛鼎之作，刀光剑影之间写尽少年意气。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20fantasy%20anime%20comic%20cover%20of%20a%20determined%20young%20cultivator%20with%20flowing%20robes%20standing%20among%20swirling%20clouds%20and%20ancient%20mountains%2C%20glowing%20spiritual%20energy%2C%20dramatic%20upward%20composition%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-02&orientation=portrait",
    updateTime: "今天 08:45",
    latestChapter: "第512话 · 剑指苍穹",
    viewCount: "1203万",
  },
  {
    id: 3,
    title: "都市异能猎人",
    author: "江白",
    status: "连载中",
    genre: "都市",
    chapters: 246,
    rating: 9.1,
    heat: 653800,
    tags: ["异能", "热血", "都市"],
    description: "夜幕下的城市藏匿着超自然存在。背负猎魔使命的少女白天是普通职员，夜晚化身异能猎人，穿梭于霓虹之间守护人间。紧张刺激的都市异能物语。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20confident%20young%20woman%20with%20superpowered%20glowing%20hands%20in%20a%20neon-lit%20modern%20city%20at%20night%2C%20urban%20skyline%2C%20dramatic%20lighting%2C%20vibrant%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%202D%20anime%20art&width=480&height=640&seq=comic-cover-03&orientation=portrait",
    updateTime: "今天 10:02",
    latestChapter: "第246话 · 霓虹之下",
    viewCount: "654万",
  },
  {
    id: 4,
    title: "剑与魔法的日常",
    author: "森见小町",
    status: "连载中",
    genre: "奇幻",
    chapters: 187,
    rating: 8.8,
    heat: 421500,
    tags: ["冒险", "轻松", "日漫"],
    description: "勇者与魔法师在冒险之余，其实过着再普通不过的生活。今天在酒馆打工，明天拯救世界，温馨搞笑的异世界日常，治愈力满满。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20cheerful%20young%20adventurer%20and%20a%20magic%20girl%20with%20staff%20smiling%20in%20a%20cozy%20fantasy%20tavern%2C%20floating%20sparkles%2C%20warm%20sunny%20palette%20with%20coral%20and%20teal%20accents%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-04&orientation=portrait",
    updateTime: "今天 11:30",
    latestChapter: "第187话 · 酒馆打烊",
    viewCount: "422万",
  },
  {
    id: 5,
    title: "美食大冒险",
    author: "陆远山",
    status: "连载中",
    genre: "美食",
    chapters: 298,
    rating: 9.2,
    heat: 587600,
    tags: ["美食", "治愈", "国漫"],
    description: "天才小厨神踏上寻找失传食谱的旅程，以美食征服一座座城镇。每一次烹饪都是情感的传递，暖胃更暖心，深夜必看的治愈神作。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20passionate%20young%20chef%20surrounded%20by%20steaming%20delicious%20dishes%2C%20warm%20kitchen%20glow%2C%20floating%20food%20ingredients%2C%20appetizing%20vibrant%20warm%20coral%20and%20amber%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-05&orientation=portrait",
    updateTime: "今天 07:55",
    latestChapter: "第298话 · 汤面的温度",
    viewCount: "588万",
  },
  {
    id: 6,
    title: "迷雾侦探社",
    author: "白泽",
    status: "连载中",
    genre: "悬疑",
    chapters: 173,
    rating: 9.3,
    heat: 498200,
    tags: ["推理", "悬疑", "都市"],
    description: "一间只接离奇案件的侦探社，一位能看见“案件真相残影”的少年侦探。层层迷雾背后，是人心与命运的博弈。烧脑推理，反转不断。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20calm%20young%20detective%20with%20magnifying%20glass%20in%20a%20moody%20foggy%20city%20street%20at%20dusk%2C%20mysterious%20atmosphere%2C%20cool%20teal%20with%20warm%20coral%20accent%20lighting%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-06&orientation=portrait",
    updateTime: "今天 12:10",
    latestChapter: "第173话 · 镜中人",
    viewCount: "498万",
  },
  {
    id: 7,
    title: "武道巅峰",
    author: "陈铁衣",
    status: "连载中",
    genre: "武侠",
    chapters: 460,
    rating: 9.5,
    heat: 1102600,
    tags: ["武侠", "热血", "国漫"],
    description: "乱世江湖，群雄并起。少年背负家族血仇，以一柄锈剑问鼎武道之巅。拳拳到肉的武打设计，快意恩仇的江湖气魄，国漫武侠又一标杆。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20wuxia%20anime%20comic%20cover%20of%20a%20fierce%20young%20martial%20artist%20with%20sword%20in%20a%20dramatic%20leaf-strewn%20ancient%20Chinese%20courtyard%2C%20dynamic%20fighting%20pose%2C%20warm%20sunset%20coral%20and%20ink%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-07&orientation=portrait",
    updateTime: "今天 09:00",
    latestChapter: "第460话 · 问鼎",
    viewCount: "1103万",
  },
  {
    id: 8,
    title: "云端机械师",
    author: "北屿",
    status: "连载中",
    genre: "科幻",
    chapters: 154,
    rating: 8.9,
    heat: 362400,
    tags: ["蒸汽", "科幻", "冒险"],
    description: "浮空之城上方，藏着最顶尖的机械工坊。天才机械师少女用一双手与一堆废铁，造出能翱翔天际的奇迹。蒸汽与齿轮的浪漫幻想诗。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20brilliant%20young%20girl%20mechanic%20holding%20a%20wrench%20in%20front%20of%20a%20giant%20steampunk%20airship%20workshop%20among%20floating%20clouds%2C%20gears%20and%20tools%2C%20warm%20coral%20and%20brass%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-08&orientation=portrait",
    updateTime: "今天 13:40",
    latestChapter: "第154话 · 上升气流",
    viewCount: "362万",
  },
  {
    id: 9,
    title: "山海异兽录",
    author: "玄鸟",
    status: "连载中",
    genre: "奇幻",
    chapters: 220,
    rating: 9.0,
    heat: 478300,
    tags: ["神话", "国漫", "冒险"],
    description: "一部行走于山海经中的博物志。少女绘师与白泽神兽结伴，走遍九州收录传说异兽，每一话都是一幅瑰丽的神话画卷。文化感与想象力兼备。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20girl%20artist%20with%20a%20brush%20and%20a%20white%20mythical%20beast%20companion%20among%20legendary%20mountain%20creatures%20and%20floating%20clouds%2C%20ink%20wash%20fantasy%20style%2C%20warm%20coral%20and%20jade%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-09&orientation=portrait",
    updateTime: "今天 06:30",
    latestChapter: "第220话 · 凤凰于飞",
    viewCount: "478万",
  },
  {
    id: 10,
    title: "热血篮球场",
    author: "小虎",
    status: "连载中",
    genre: "运动",
    chapters: 132,
    rating: 8.7,
    heat: 315900,
    tags: ["运动", "青春", "热血"],
    description: "一支不被看好的高中篮球队，一颗绝不服输的赤子之心。从县赛打到全国，汗水与友情点燃整个夏天，青春就该这样酣畅淋漓。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20determined%20young%20basketball%20player%20mid-dunk%20in%20a%20sunlit%20indoor%20court%2C%20dynamic%20motion%2C%20cheering%20crowd%20blurred%2C%20vibrant%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-10&orientation=portrait",
    updateTime: "今天 15:20",
    latestChapter: "第132话 · 压哨绝杀",
    viewCount: "316万",
  },
  {
    id: 11,
    title: "梦回长安",
    author: "云砚",
    status: "已完结",
    genre: "古风",
    chapters: 96,
    rating: 9.0,
    heat: 289700,
    tags: ["古风", "历史", "国漫"],
    description: "一梦千年，回到盛世长安。现代女子一朝醒来身处大唐，用才学与见识在乱世中书写属于自己的传奇。古风国漫，诗意盎然。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20anime%20comic%20cover%20of%20an%20elegant%20woman%20in%20hanfu%20overlooking%20the%20grand%20Chang&width=480&height=640&seq=comic-cover-11&orientation=portrait'an city rooftops at dawn, lanterns and poetry scrolls, warm coral sunrise and ink teal palette, clean minimal background, high detail anime art",
    updateTime: "昨天 18:00",
    latestChapter: "第96话 · 完结篇",
    viewCount: "290万",
  },
  {
    id: 12,
    title: "机甲少年团",
    author: "千夜",
    status: "连载中",
    genre: "科幻",
    chapters: 210,
    rating: 9.1,
    heat: 568400,
    tags: ["机甲", "青春", "热血"],
    description: "少年们被选入地球防卫学院，驾驶心念相连的机甲迎战外星入侵。团队成长、热血出击，一话更比一话燃，机甲迷不容错过。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20squad%20of%20young%20pilots%20standing%20before%20a%20giant%20towering%20mecha%20robot%2C%20school%20academy%20background%2C%20heroic%20composition%2C%20vibrant%20warm%20coral%20and%20steel%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-12&orientation=portrait",
    updateTime: "今天 08:15",
    latestChapter: "第210话 · 最后的防线",
    viewCount: "568万",
  },
  {
    id: 13,
    title: "校园灵异事件簿",
    author: "夜猫子",
    status: "连载中",
    genre: "悬疑",
    chapters: 118,
    rating: 8.6,
    heat: 276300,
    tags: ["校园", "悬疑", "惊悚"],
    description: "每到午夜，教学楼七楼就会多出一间教室。少年班长与通灵少女联手，把学校里的灵异怪谈一件件调查到底。细思极恐，却也温暖动人。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20two%20brave%20high%20school%20students%20with%20flashlight%20in%20a%20dim%20eerie%20school%20corridor%20at%20midnight%2C%20mysterious%20glowing%20door%2C%20spooky%20yet%20stylized%2C%20cool%20teal%20with%20warm%20coral%20accent%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-13&orientation=portrait",
    updateTime: "今天 14:05",
    latestChapter: "第118话 · 七楼的教室",
    viewCount: "276万",
  },
  {
    id: 14,
    title: "灵魂烘焙师",
    author: "苏打",
    status: "连载中",
    genre: "治愈",
    chapters: 89,
    rating: 8.9,
    heat: 201800,
    tags: ["治愈", "美食", "日常"],
    description: "一间藏在巷尾的烘焙店，店主能用甜点唤起客人遗忘的记忆。每一块蛋糕背后都藏着一个温柔的故事，治愈系的甜品物语。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20kind%20pastry%20chef%20holding%20a%20beautifully%20decorated%20cake%20in%20a%20warm%20cozy%20bakery%2C%20flour%20dust%20and%20soft%20golden%20light%2C%20gentle%20heartwarming%20mood%2C%20warm%20coral%20and%20cream%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-14&orientation=portrait",
    updateTime: "今天 16:00",
    latestChapter: "第89话 · 樱花马卡龙",
    viewCount: "202万",
  },
  {
    id: 15,
    title: "星际佣兵",
    author: "孤舟",
    status: "连载中",
    genre: "科幻",
    chapters: 175,
    rating: 8.8,
    heat: 342900,
    tags: ["星际", "热血", "佣兵"],
    description: "拿钱办事，绝不留情。一群游走在银河边缘的佣兵，接下一个个生死任务，在枪林弹雨中缔造传说。硬核科幻动作漫，节奏爽快。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20rugged%20mercenary%20squad%20with%20blasters%20in%20a%20gritty%20outer%20space%20corridor%2C%20planet%20and%20starfield%20visible%20through%20window%2C%20cool%20steel%20teal%20with%20warm%20coral%20accents%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-15&orientation=portrait",
    updateTime: "今天 17:30",
    latestChapter: "第175话 · 灰烬行动",
    viewCount: "343万",
  },
  {
    id: 16,
    title: "魔法学院新生",
    author: "栗子",
    status: "连载中",
    genre: "校园",
    chapters: 142,
    rating: 8.7,
    heat: 289100,
    tags: ["魔法", "校园", "轻松"],
    description: "不会魔法的新生，意外进入了世界顶尖魔法学院。为了证明自己，她用“笨办法”闯出一条另类道路，爆笑又励志的魔法校园日常。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20clumsy%20enthusiastic%20student%20with%20a%20spellbook%20in%20a%20grand%20magical%20academy%20courtyard%2C%20floating%20books%20and%20glowing%20spells%2C%20cheerful%20youthful%20mood%2C%20vibrant%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-16&orientation=portrait",
    updateTime: "今天 09:50",
    latestChapter: "第142话 · 魔法的温度",
    viewCount: "289万",
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Wide%20stylized%20anime%20illustration%20of%20a%20vibrant%20manga%20reading%20scene%20with%20floating%20comic%20pages%2C%20dynamic%20characters%2C%20books%20and%20glowing%20sparks%2C%20warm%20coral%20orange%20and%20deep%20teal%20color%20palette%2C%20energetic%20youthful%20composition%2C%20rich%20detail%2C%20no%20text%2C%20high%20resolution%20digital%20anime%20art&width=1600&height=900&seq=hero-tiantian&orientation=landscape";

export const todayUpdates: UpdateItem[] = [
  { id: 1, comicId: 2, title: "九霄破", chapter: "第512话 · 剑指苍穹", time: "08:45", tag: "国漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20fantasy%20anime%20comic%20cover%20of%20a%20determined%20young%20cultivator%20with%20flowing%20robes%20standing%20among%20swirling%20clouds%20and%20ancient%20mountains%2C%20glowing%20spiritual%20energy%2C%20dramatic%20upward%20composition%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-02&orientation=portrait" },
  { id: 2, comicId: 1, title: "星海之刃", chapter: "第328话 · 深渊之门", time: "09:20", tag: "日漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20heroic%20young%20swordsman%20holding%20a%20glowing%20blade%20aboard%20a%20futuristic%20spaceship%2C%20starry%20nebula%20backdrop%2C%20dynamic%20dramatic%20pose%2C%20vibrant%20warm%20coral%20and%20teal%20color%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%202D%20anime%20art&width=480&height=640&seq=comic-cover-01&orientation=portrait" },
  { id: 3, comicId: 3, title: "都市异能猎人", chapter: "第246话 · 霓虹之下", time: "10:02", tag: "国漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20confident%20young%20woman%20with%20superpowered%20glowing%20hands%20in%20a%20neon-lit%20modern%20city%20at%20night%2C%20urban%20skyline%2C%20dramatic%20lighting%2C%20vibrant%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%202D%20anime%20art&width=480&height=640&seq=comic-cover-03&orientation=portrait" },
  { id: 4, comicId: 5, title: "美食大冒险", chapter: "第298话 · 汤面的温度", time: "07:55", tag: "国漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20passionate%20young%20chef%20surrounded%20by%20steaming%20delicious%20dishes%2C%20warm%20kitchen%20glow%2C%20floating%20food%20ingredients%2C%20appetizing%20vibrant%20warm%20coral%20and%20amber%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-05&orientation=portrait" },
  { id: 5, comicId: 7, title: "武道巅峰", chapter: "第460话 · 问鼎", time: "09:00", tag: "国漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20wuxia%20anime%20comic%20cover%20of%20a%20fierce%20young%20martial%20artist%20with%20sword%20in%20a%20dramatic%20leaf-strewn%20ancient%20Chinese%20courtyard%2C%20dynamic%20fighting%20pose%2C%20warm%20sunset%20coral%20and%20ink%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-07&orientation=portrait" },
  { id: 6, comicId: 12, title: "机甲少年团", chapter: "第210话 · 最后的防线", time: "08:15", tag: "日漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20squad%20of%20young%20pilots%20standing%20before%20a%20giant%20towering%20mecha%20robot%2C%20school%20academy%20background%2C%20heroic%20composition%2C%20vibrant%20warm%20coral%20and%20steel%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-12&orientation=portrait" },
  { id: 7, comicId: 4, title: "剑与魔法的日常", chapter: "第187话 · 酒馆打烊", time: "11:30", tag: "日漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20cheerful%20young%20adventurer%20and%20a%20magic%20girl%20with%20staff%20smiling%20in%20a%20cozy%20fantasy%20tavern%2C%20floating%20sparkles%2C%20warm%20sunny%20palette%20with%20coral%20and%20teal%20accents%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-04&orientation=portrait" },
  { id: 8, comicId: 6, title: "迷雾侦探社", chapter: "第173话 · 镜中人", time: "12:10", tag: "日漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20calm%20young%20detective%20with%20magnifying%20glass%20in%20a%20moody%20foggy%20city%20street%20at%20dusk%2C%20mysterious%20atmosphere%2C%20cool%20teal%20with%20warm%20coral%20accent%20lighting%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-06&orientation=portrait" },
  { id: 9, comicId: 8, title: "云端机械师", chapter: "第154话 · 上升气流", time: "13:40", tag: "日漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20brilliant%20young%20girl%20mechanic%20holding%20a%20wrench%20in%20front%20of%20a%20giant%20steampunk%20airship%20workshop%20among%20floating%20clouds%2C%20gears%20and%20tools%2C%20warm%20coral%20and%20brass%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-08&orientation=portrait" },
  { id: 10, comicId: 13, title: "校园灵异事件簿", chapter: "第118话 · 七楼的教室", time: "14:05", tag: "日漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20two%20brave%20high%20school%20students%20with%20flashlight%20in%20a%20dim%20eerie%20school%20corridor%20at%20midnight%2C%20mysterious%20glowing%20door%2C%20spooky%20yet%20stylized%2C%20cool%20teal%20with%20warm%20coral%20accent%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-13&orientation=portrait" },
  { id: 11, comicId: 10, title: "热血篮球场", chapter: "第132话 · 压哨绝杀", time: "15:20", tag: "日漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20determined%20young%20basketball%20player%20mid-dunk%20in%20a%20sunlit%20indoor%20court%2C%20dynamic%20motion%2C%20cheering%20crowd%20blurred%2C%20vibrant%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-10&orientation=portrait" },
  { id: 12, comicId: 14, title: "灵魂烘焙师", chapter: "第89话 · 樱花马卡龙", time: "16:00", tag: "国漫", cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20comic%20cover%20of%20a%20kind%20pastry%20chef%20holding%20a%20beautifully%20decorated%20cake%20in%20a%20warm%20cozy%20bakery%2C%20flour%20dust%20and%20soft%20golden%20light%2C%20gentle%20heartwarming%20mood%2C%20warm%20coral%20and%20cream%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20art&width=480&height=640&seq=comic-cover-14&orientation=portrait" },
];

export const featuredComic: Comic = comics[1];

export const faqItems: FaqItem[] = [
  {
    q: "天天漫画网每天几点更新最新话？",
    a: "天天漫画网每天凌晨开始陆续更新连载漫画的最新话，热门作品大多在上午 8 点至下午 6 点之间集中上线。你可以打开首页的「今日更新」版块，第一时间掌握各作品的最新动态，追更不迷路。",
  },
  {
    q: "追更需要注册登录吗？",
    a: "目前浏览今日更新和人气榜单无需注册即可使用。如果你希望收藏喜欢的漫画、接收更新提醒，可以点击导航栏的「追更」按钮，按提示创建账号后即可开启个性化追更功能。",
  },
  {
    q: "在哪里能看到我收藏漫画的更新提醒？",
    a: "收藏并开启提醒后，只要该作品更新最新话，我们就会在首页「我的追更」区域为你高亮展示，避免错过任何一话的关键剧情。",
  },
  {
    q: "日漫和国漫的更新频率一样吗？",
    a: "不太一样。大部分热门国漫保持周更或隔日更，热门日漫则多按原版连载节奏更新。我们会在每部作品的详情页标注更新频率与最近更新时间，方便你安排追更计划。",
  },
  {
    q: "发现某部作品很久没更新了怎么办？",
    a: "连载作品偶尔会因作者休刊或汉化进度而短暂停更。你可以在作品详情页查看「公告」了解原因，也可以收藏后留意后续更新提醒，复更时我们会第一时间通知你。",
  },
  {
    q: "天天漫画网支持哪些设备访问？",
    a: "网站采用响应式设计，电脑、平板和手机均可流畅访问。无论你用哪种设备，都能获得清晰舒适的阅读与追更体验。",
  },
];